/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Browser_Extensions_Tlm_2Inputs */

const en_svc_browser_extensions_tlm_2 = /** @type {(inputs: Svc_Browser_Extensions_Tlm_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`architecture`)
};

const ar_svc_browser_extensions_tlm_2 = /** @type {(inputs: Svc_Browser_Extensions_Tlm_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`البنية`)
};

const bn_svc_browser_extensions_tlm_2 = /** @type {(inputs: Svc_Browser_Extensions_Tlm_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`architecture`)
};

const de_svc_browser_extensions_tlm_2 = /** @type {(inputs: Svc_Browser_Extensions_Tlm_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Architektur`)
};

const es_svc_browser_extensions_tlm_2 = /** @type {(inputs: Svc_Browser_Extensions_Tlm_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`arquitectura`)
};

const fr_svc_browser_extensions_tlm_2 = /** @type {(inputs: Svc_Browser_Extensions_Tlm_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Architecture`)
};

const pt_svc_browser_extensions_tlm_2 = /** @type {(inputs: Svc_Browser_Extensions_Tlm_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Arquitetura`)
};

const zh_svc_browser_extensions_tlm_2 = /** @type {(inputs: Svc_Browser_Extensions_Tlm_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`架构`)
};

const tr_svc_browser_extensions_tlm_2 = /** @type {(inputs: Svc_Browser_Extensions_Tlm_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`mimarisi`)
};

const ru_svc_browser_extensions_tlm_2 = /** @type {(inputs: Svc_Browser_Extensions_Tlm_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`архитектура`)
};

const pl_svc_browser_extensions_tlm_2 = /** @type {(inputs: Svc_Browser_Extensions_Tlm_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Architektura`)
};

/**
* | output |
* | --- |
* | "architecture" |
*
* @param {Svc_Browser_Extensions_Tlm_2Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_browser_extensions_tlm_2 = /** @type {((inputs?: Svc_Browser_Extensions_Tlm_2Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Browser_Extensions_Tlm_2Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_browser_extensions_tlm_2(inputs)
	if (locale === "bn") return bn_svc_browser_extensions_tlm_2(inputs)
	if (locale === "de") return de_svc_browser_extensions_tlm_2(inputs)
	if (locale === "es") return es_svc_browser_extensions_tlm_2(inputs)
	if (locale === "fr") return fr_svc_browser_extensions_tlm_2(inputs)
	if (locale === "pt") return pt_svc_browser_extensions_tlm_2(inputs)
	if (locale === "zh") return zh_svc_browser_extensions_tlm_2(inputs)
	if (locale === "tr") return tr_svc_browser_extensions_tlm_2(inputs)
	if (locale === "ru") return ru_svc_browser_extensions_tlm_2(inputs)
	if (locale === "pl") return pl_svc_browser_extensions_tlm_2(inputs)
	return en_svc_browser_extensions_tlm_2(inputs)
});
export { svc_browser_extensions_tlm_2 as "svc_browser-extensions_tlm_2" }